module.exports = __webpack_public_path__ + "media/images/brands/logo_energiefranken_gross-e371debd8e07353f3aa29671b47e5509.png";